import access_deniedComponent from './access_denied.component';

let access_deniedModule = angular.module('access_denied', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/app/login');

  $stateProvider
    .state('access_denied', {
      url: '/access_denied',
      component: 'accessDenied',
      data: {
        requireLogin: true
      },
      parent:'app',
    });
})

.component('accessDenied', access_deniedComponent)

.name;

export default access_deniedModule;


// WEBPACK FOOTER //
// ./client/app/components/access_denied/index.js